module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_6005.bdd36398.png";